export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعادة تعيين"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختيار الكل"])}
}